__turbopack_context__.v({
  "alignLeft": "FeaturedPackage-module__o72oTa__alignLeft",
  "badgeBest": "FeaturedPackage-module__o72oTa__badgeBest",
  "badgeEmi": "FeaturedPackage-module__o72oTa__badgeEmi",
  "badgeSeats": "FeaturedPackage-module__o72oTa__badgeSeats",
  "body": "FeaturedPackage-module__o72oTa__body",
  "card": "FeaturedPackage-module__o72oTa__card",
  "cardCategory": "FeaturedPackage-module__o72oTa__cardCategory",
  "cardImage": "FeaturedPackage-module__o72oTa__cardImage",
  "cardIncludes": "FeaturedPackage-module__o72oTa__cardIncludes",
  "cardSubtitle": "FeaturedPackage-module__o72oTa__cardSubtitle",
  "cardTimer": "FeaturedPackage-module__o72oTa__cardTimer",
  "cardTitle": "FeaturedPackage-module__o72oTa__cardTitle",
  "discountTag": "FeaturedPackage-module__o72oTa__discountTag",
  "duration": "FeaturedPackage-module__o72oTa__duration",
  "flightSubTextTip": "FeaturedPackage-module__o72oTa__flightSubTextTip",
  "footer": "FeaturedPackage-module__o72oTa__footer",
  "footerContent": "FeaturedPackage-module__o72oTa__footerContent",
  "header": "FeaturedPackage-module__o72oTa__header",
  "headingBlock": "FeaturedPackage-module__o72oTa__headingBlock",
  "imageLink": "FeaturedPackage-module__o72oTa__imageLink",
  "imageWrap": "FeaturedPackage-module__o72oTa__imageWrap",
  "includeIcon": "FeaturedPackage-module__o72oTa__includeIcon",
  "inclusion": "FeaturedPackage-module__o72oTa__inclusion",
  "nightsBadge": "FeaturedPackage-module__o72oTa__nightsBadge",
  "oldPrice": "FeaturedPackage-module__o72oTa__oldPrice",
  "perPerson": "FeaturedPackage-module__o72oTa__perPerson",
  "price": "FeaturedPackage-module__o72oTa__price",
  "priceBlock": "FeaturedPackage-module__o72oTa__priceBlock",
  "rating": "FeaturedPackage-module__o72oTa__rating",
  "section": "FeaturedPackage-module__o72oTa__section",
  "slickSlide": "FeaturedPackage-module__o72oTa__slickSlide",
  "slickWrap": "FeaturedPackage-module__o72oTa__slickWrap",
  "slider": "FeaturedPackage-module__o72oTa__slider",
  "standard-subheading": "FeaturedPackage-module__o72oTa__standard-subheading",
  "starting": "FeaturedPackage-module__o72oTa__starting",
  "titleLink": "FeaturedPackage-module__o72oTa__titleLink",
  "titleRow": "FeaturedPackage-module__o72oTa__titleRow",
  "viewDealsBtn": "FeaturedPackage-module__o72oTa__viewDealsBtn",
});
